<woods-navbar></woods-navbar>
<div class="">

    <woods-carousel-galeria></woods-carousel-galeria>

    
</div>

<woods-footer></woods-footer>